<template>
    <div class="goods">
        <Head
            :headInfo='headInfo'
            :leftArrowShow='false'
        />
        <div class="banner" :style="{width: pageWidth+'px'}">
            <van-swipe :autoplay="3000" indicator-color="#ff7a45" :style="{height: pageWidth+'px'}">
                <van-swipe-item v-for="(item, index) in goods.skuPictureBoList" :key="index" :style="{height: pageWidth+'px'}" class="banner-parent">
                    <img v-lazy="item + '?x-oss-process=image/resize,w_600,h_600/quality,Q_100'" class="banner-item" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="navTitle">
            <div class="title">
                <div class="content" v-text="goods.skuName"></div>
                <div class="price">成为单分享会员，立享会员批发价</div>
            </div>
        </div>
        <div class="mark  mtop20 borderBotLeft0 col999" >
            <img class="serveImg" src="../../../assets/img/b2b/icon_zp.png" alt="">正品保障&店铺售后<div class="item"></div>
        </div>
        <div class="mtop20">
            <ShopName :shopName='shopName' />
        </div>
        <div class="contentDetail mtop20">
            <v-switcher :headers="headerCenter" align="center">
                <div class="demo-item textCenter" slot="0" v-html="detail">
                </div>
            </v-switcher>
        </div>
        <div class="foot">
            <div class="btn" :class="{'active': isStart || !goods.inventoryRemainNum}" @click="onPen(2)">立即购买</div>
        </div>
        <van-overlay :show="showNew" @touchmove.prevent :z-index=10000 @click="showNew = false">
            <div class="wrapper" >
                <div class="overblock">
                    <img src="../../../assets/img/b2b/sharePic.png" alt="">
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Head from '../../common/head'
import { shopInfo } from '../api/api'
import { mapActions } from 'vuex'
import ShopName from '../common/shopNameTemplate' // 小店
import { getOpenSkuGoodsDetail } from '../api/product'
export default {
    name: 'shareGoods',
    components: {
        Head,
        ShopName
    },
    data () {
        return {
            headInfo: {
                title: '商品详情'
            },
            headerCenter: ['商品介绍'],
            showNew: false,
            specifications: [],
            spikeId: '',
            skuId: '',
            goods: {},
            parameterList2: [],
            bannerImgList: [],
            detail: '',
            popupVisible: false,
            popupVisible2: false,
            popupVisible3: false,
            sku: {},
            rebatePrice: 0,
            priceRebate: 0,
            rebatePriceHtml: '',
            picUrl: '',
            isStart: true,
            pageWidth: '320',
            timeDown: 0,
            timeHtml: '距离结束',
            shopName: '',
            userInfo: '',
            activityParams: ''
        }
    },
    methods: {
        ...mapActions(['setActivity', 'setBuried', 'getSkuGoodsDetail']),
        onBack () {
        },
        onCount () {
            this.timeHtml = '活动结束'
            this.isStart = true
        },
        onBuy () {
        },
        onPen () {
            this.showNew = true
        },
        onNumber () {
            this.getRebate()
        },
        timeString () {
            let nowtime = this.getTimeString(this.goods.nowTime)
            let startTime = this.getTimeString(this.goods.startTime)
            let endTime = this.getTimeString(this.goods.endTime)
            this.isStart = startTime < nowtime
            if (nowtime > startTime) {
                this.timeHtml = '距离结束'
                this.timeDown = endTime - nowtime
                this.isStart = false
            } else {
                this.timeHtml = '距离开始'
                this.timeDown = startTime - nowtime
                this.isStart = true
            }
        },
        getTimeString (data) {
            return new Date(data.replace(/-/g, '/')).getTime()
        },
        async getRebate () {
            await this.getRebateData({
                skuNum: this.goods.quantity,
                skuId: this.goods.skuId
            }).then((data) => {
                this.rebatePrice = data.maxRebate
            })
        },
        async getGoodsDetail (type) {
            await getOpenSkuGoodsDetail({
                skuId: this.skuId,
                spikeId: this.spikeId
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.specifications = data.skuParameterBoList ? JSON.parse(data.skuParameterBoList) : ''
                // if (data.skuRebateBoList.length) {
                //     let name = ''
                //     let arr = []
                //     data.skuRebateBoList.forEach((item) => {
                //         if (item.type == 1) {
                //             name = '直接返利' + item.discount + '%'
                //         } else if (item.type == 2) {
                //             name = '满' + item.reachValue + '金额返利' + item.discount + '%'
                //         } else {
                //             name = '满' + item.reachValue + '件返利' + item.discount + '%'
                //         }
                //         arr.push(name)
                //     })
                //     this.rebatePriceHtml = arr.join(',')
                // }
                data.quantity = 1
                if (data.spuDetailList) {
                    this.detail = data.spuDetailList
                }
                if (data.skuPictureBoList) {
                    this.picUrl = data.skuPictureBoList[0]
                }
                this.goods = data
                this.timeString()
                // this.getRebate()
                this.activityInfo()
                this.getShopInfo()
            })
        },
        activityInfo () {
            this.activityParams.productId = this.skuId
            this.activityParams.productName = this.goods.skuName
            this.setActivity(this.activityParams)
            this.goodShow = true
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
        },
        async buryPoint (event) {
            this.setBuried({ event: event })
        },
        // 店铺信息
        async getShopInfo () {
            const { data } = await shopInfo({
                merchantCode: this.goods.merchantCode
            })
            this.shopName = data.shopName
        }
    },
    mounted () {
        this.activityParams = JSON.parse(localStorage.getItem('spikeData'))
        this.goodsDetailBack = localStorage.getItem('goodsDetailBack')
        this.tab = localStorage.getItem('tab') || 0
        this.pageWidth = document.documentElement.clientWidth
        this.skuId = this.$route.query.skuId
        this.spikeId = this.$route.query.spikeId
        this.getGoodsDetail()
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            // 微信 打开埋点
            this.buryPoint(93)
        } else {
            this.buryPoint(87)
        }
    },
    beforeRouteEnter (to, from, next) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger' && to.query.isWeixin) {
            // 微信
            next(vm => {
                vm.showNew = false
            })
        } else if (to.query.isWeixin) {
            // 判断原生
            // window.location.href = 'dfx://'
            setTimeout(function () {
                window.location.href = '/newshareh5/b2b/downdfx?spikeId=' + to.query.spikeId + '&skuId=' + to.query.skuId + '&type=' + to.query.type + '&invitationCode=' + to.query.invitationCode + '&homeType=' + to.query.homeType
                // this.$route.push({ path: '/common/downDfx', query: {} }) // android下载地址
            }, 500)
        } else {
            next(vm => {
                vm.showNew = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.overblock{
    width: 396px;
    height: 184px;
    right: 48px;
    top: 20px;
    position: absolute;
}
.goods {
    font-size: 28px;
    padding-bottom: 150px;
    background: #f5f5f5;
    position: relative;
    width: 100%;
    .banner {
        height: 100vw;
        position: relative;
        .banner-item {
            display: inline-block;
            width: 100%;
            height: 100%;
            margin: 0 auto;
            background: #f2f3f5;
            object-fit: cover;
        }
    }
    .navTitle {
        .head {
            height: 120px;
            line-height: 120px;
            color: #ffffff;
            display: flex;
            justify-content: space-between;
            .headLeft {
                flex: 1;
                background: #ff4d4f;
                font-size: 48px;
                padding-left: 32px;
                box-sizing: border-box;
                span {
                    font-size: 32px;
                }
                sub {
                    margin-left: 18px;
                    font-size: 22px;
                    text-decoration: line-through;
                }
            }
            .headRight {
                flex: 0 0 244px;
                line-height: normal;
                padding: 18px 0;
                font-size: 22px;
                text-align: center;
                box-sizing: border-box;
                color: #000000;
                background: #ffeded;
                .describe {
                    margin-bottom: 12px;
                    position: relative;
                    padding-left: 26px;
                    &::before {
                        content: '';
                        position: absolute;
                        background: url(../../../assets/img/b2b/time2.png)
                            no-repeat;
                        background-size: 100% 100%;
                        width: 32px;
                        height: 32px;
                        left: 50px;
                        top: 0;
                    }
                }
                .time {
                    font-size: 20px;
                }
            }
        }
        .title {
            padding: 28px 96px 28px 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            background: #ffffff;
            .content {
                line-height: 42px;
                font-size: 30px;
                color: #333333;
                font-weight: 500;
                word-wrap: break-word;
                word-break: break-all;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                margin-bottom: 16px;
            }
            .price{
                font-size: 36px;
                color: #ff7a45;
            }
        }
    }
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        color: #999999;
        .item {
            float: right;
            margin-right: 40px;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        img {
            width: 32px;
            height: 32px;
            vertical-align: sub;
            margin-right: 4px;
        }
    }
    .arrAbte::after {
        position: absolute;
        content: '';
        top: 32px;
        right: 28px;
        width: 40px;
        height: 40px;
        background: url(../../../assets/img/b2b/system_help@2x.png) no-repeat;
        background-size: 100%;
    }
    .contentDetail {
        background: #ffffff;
        .demo-item {
            min-height: 200px;
            box-sizing: border-box;
        }
        .cont {
            padding: 32px;
            z-index: 99;
            .btn {
                float: right;
                width: 208px;
                height: 64px;
                line-height: 64px;
                font-size: 28px;
                text-align: center;
                border-radius: 64px;
                color: #ffffff;
                background: #ff4d4f;
                &.active {
                    background: #ccc;
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 32px;
        z-index: 99;
        .btn {
            float: right;
            width: 208px;
            height: 64px;
            line-height: 64px;
            font-size: 28px;
            text-align: center;
            border-radius: 64px;
            color: #ffffff;
            background: #ff4d4f;
            &.active {
                background: #ccc;
            }
        }
    }
}
.mint-popup-bottom {
    width: 100%;
    background: #f5f5f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .conpon {
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
            .close {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 24px;
                top: 10px;
            }
        }
        .server {
            height: 900px;
            padding: 32px;
            .ratePrice {
                margin-bottom: 80px;
            }
            .rabateSm {
                margin-bottom: 48px;
                .title {
                    margin-bottom: 16px;
                }
            }
            .serveImg {
                width: 32px;
                height: 32px;
                vertical-align: sub;
                padding-right: 4px;
            }
        }
    }
    .select {
        padding: 24px;
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .head {
            display: flex;
            justify-content: space-between;
            position: relative;
            padding-bottom: 40px;
            .img {
                width: 220px;
                height: 220px;
                flex: 0 0 220px;
                background: #999999;
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    margin: 0 auto;
                    background: #f2f3f5;
                    object-fit: cover;
                }
            }
            .title2 {
                margin-left: 24px;
                flex: 0 0 460px;
                display: flex;
                align-content: space-between;
                flex-wrap: wrap;
                .close {
                    flex: 0 0 100%;
                    overflow: hidden;
                    img {
                        width: 48px;
                        height: 48px;
                        float: right;
                    }
                }
                .img {
                    width: 220px;
                    height: 220px;
                    flex: 0 0 220px;
                    background: #999999;
                    img {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                        margin: 0 auto;
                        background: #f2f3f5;
                        object-fit: cover;
                    }
                }
                .goodsBt {
                    .price {
                        flex: 0 0 100%;
                        font-size: 34px;
                        color: #ff7a45;
                        height: 48px;
                        sub {
                            font-size: 22px;
                        }
                        span {
                            font-size: 24px;
                            color: #999999;
                            margin-left: 32px;
                            text-decoration: line-through;
                            sub {
                                font-size: 16px;
                            }
                        }
                    }
                    .cont {
                        font-size: 24px;
                        color: #333333;
                        line-height: 36px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                    .gg {
                        font-size: 24px;
                        line-height: 30px;
                        height: 60px;
                        width: 360px;
                        margin-top: 12px;
                        color: #666666;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        word-wrap: break-word;
                        word-break: break-all;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    .rebateList {
        display: flex;
        justify-content: flex-start;
        font-size: 28px;
        padding: 32px 0;
        border-bottom: 2px solid #eeeeee;
        position: relative;
        .rebateLeft {
            flex: 0 0 144px;
            color: #333333;
        }
        .rebateRight {
            color: #999999;
            line-height: 40px;
        }
    }
    .rebate {
        text-align: right;
        font-size: 24px;
        margin-top: 10px;
        color: #ff7a45;
    }
    .nums {
        display: flex;
        justify-content: space-between;
        margin-top: 28px;
        line-height: 60px;
        .cartN {
            flex: 0 0 400px;
            position: relative;
            .xg {
                position: absolute;
                left: 60px;
                color: #ff7a45;
                font-size: 24px;
            }
        }
        .num {
            display: flex;
            justify-content: flex-end;
            span {
                display: inline-block;
                width: 66px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                &.jian {
                    background: url(../../../assets/img/b2b/btn_reduce@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
                &.jian2 {
                    background: url(../../../assets/img/b2b/btn_reduce_pre@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
                &.jia {
                    background: url(../../../assets/img/b2b/btn_add@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
                &.w38 {
                    width: 76px;
                    font-size: 32px;
                    background: #f5f5f5;
                    margin: 0 2px;
                }
            }
        }
    }
    .fot {
        padding: 32px;
        background: #ffffff;
        .btn {
            display: flex;
            justify-content: space-between;
            .btn1 {
                width: 208px;
                height: 64px;
                line-height: 64px;
                border-radius: 64px;
                text-align: center;
                margin: 0 10px;
                color: #ff7a45;
                &.btnBg {
                    background: #ff7a45;
                    color: #ffffff;
                }
                &.btnRed {
                    background: #ff4d4f;
                    color: #ffffff;
                }
                &.oss2 {
                    border: 0.026667rem solid #ccc;
                    color: #fff;
                    background: #ccc;
                    width: 100%;
                }
            }
        }
    }
}
/deep/ .v-switcher-header-anchor {
    height: 2px;
    background-color: #ff7a45;
    bottom: 0;
}
/deep/ .v-switcher-header-item.is-active {
    color: #ff7a45;
}
/deep/ .mint-swipe-indicator {
    width: 14px;
    height: 14px;
    margin: 10px;
    border-radius: 50%;
}
/deep/ .mint-swipe-indicator.is-active {
    background: #ff7a45;
}
/deep/ .v-switcher-header-item {
    width: 50%;
    font-size: 28px !important;
}
/deep/ .v-switcher-header-tabs {
    border-bottom: 1px solid #d1d1d6;
}
</style>
<style lang="scss">
body.dialog-open {
    position: fixed;
    width: 100%;
}
</style>
